import { useState, useEffect } from 'react';
import { axiosApi } from '../../api/setupApi';

const useSubtotalsByYearCIS = (year, section = 'bohol') => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!year) {
      setData(null);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchSubtotals = async () => {
      setLoading(true);
      setError(null);

      const getBaseCandidates = (targetSection) => {
        if (targetSection === 'siquijor') {
          return ['cisSiquijor', 'cissiquijor', 'cisSiquijior', 'cissiquijior'];
        }
        return ['cisBohol', 'cisbohol'];
      };

      const bases = getBaseCandidates(section);
      let lastError = null;

      for (const base of bases) {
        try {
          const { data } = await axiosApi.get(`/${base}/subtotal/${year}`);
          if (data && data.success) {
            setData(data.data);
          } else {
            setData(data || null);
          }
          setLoading(false);
          return;
        } catch (err) {
          lastError = err;
        }
      }

      console.error('Error fetching subtotals:', lastError);
      setError(lastError?.response?.data?.error || lastError?.message || lastError?.toString());
      setLoading(false);
    };

    fetchSubtotals();
  }, [year, section]);

  return { data, loading, error };
};

export default useSubtotalsByYearCIS;